import {
    ADD_CONTCACT_REQUEST,
    ADD_CONTCACT_SUCCESS,
    ADD_CONTCACT_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const addContactReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CONTCACT_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ADD_CONTCACT_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ADD_CONTCACT_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default addContactReducer;
